<template>
  <b-container>
    <b-row>
      <b-col cols=6
      offset=3>
        <h1>Sign in</h1>
        <router-link to="/register"
        class="text-success mb-4">
          Need an account?
        </router-link>
        <b-form
        @submit.stop.prevent="login">
          <b-form-invalid-feedback :state="stateLogin">
            <div v-for="([ key, error]) in errors"
            class="text-danger"
            :key="key">
              <div v-for="item in error"
              :key="item">
                {{ key }} {{ item }}
              </div>
            </div>
          </b-form-invalid-feedback>
          <b-form-input 
          required 
          type="email"
          name="email"
          autocomplete="on"
          :disabled="isLoading"
          v-model="email"
          placeholder="Email" 
          class="mb-3"/>
          <b-form-input 
          required
          type="password"
          name="password"
          autocomplete="on"
          :disabled="isLoading"
          v-model="password"
          placeholder="Password" 
          class="mb-3"/>
          <b-button 
          type="submit"
          :disabled="isLoading"
          :class="isLoading ? 'btn-disabled' : 'btn-success'">
            Sign in
          </b-button>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import store from '@/store'

export default {
  metaInfo () {
    return {
      title: `Login | test-almocogratis`
    }
  },
  beforeRouteEnter (to, from, next) {
    if (store.getters['user/data']) next('/')
    else next()
  },
  data () {
    return {
      stateLogin: true,
      isLoading: false,
      email: undefined,
      password: undefined,
      errors: []
    }
  },
  methods: {
    async login () {
      this.isLoading = true
      await this.$http.login({
          user: {
            email: this.email, 
            password: this.password
          }
        })
        .then( ({ data }) => {
          this.setStore('user/data', data.user)
          this.setStore('user/jwtToken', data.user.token)
          this.$router.push({ name: 'Home' })
        }).then().catch(err => {
          this.errors = Object.entries(err.response.data.errors)
          this.stateLogin = false
        }).finally(() => {
          this.isLoading = false
          this.email = undefined
          this.password = undefined
        })
    }
  }
}
</script>

<style>

</style>